import type { AclsContextItem } from './types';

export function getProfileIdFromAclsContextItem(
  contextItem: AclsContextItem,
): string | undefined {
  // Profile ID is group_id or user_id of the corresponding acl item.
  let profileId: string | undefined;
  if ('user_id' in contextItem) {
    profileId = contextItem.user_id;
  }
  if ('group_id' in contextItem) {
    profileId = contextItem.group_id;
  }
  return profileId;
}
